import { auth } from '@/firebase'
import $store from '@/store'
import Vue from 'vue'
import Router from 'vue-router'
import { siteName } from '@/config/app'
import routes from './routes'
import { logPageView } from '@/analytics'

Vue.use(Router)

const router = new Router(routes)

router.beforeEach(async (to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title)
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + ` - ${siteName}`
  } else {
    document.title = siteName
  }

  // if the user isn't going to /login or isn't logged in, wait for a login or redirect to /login
  if (!to.meta.public || auth.currentUser) {
    auth.onAuthStateChanged(async (user) => {
      if (!user) {
        next({
          path: '/login',
          query: { redirect: to.fullPath, email: from.query.email }
        })
        return
      }

      if (to.path === '/') {
        next({ path: '/dashboard' })
        return
      }

      const goToUsers = async () => {
        await $store.dispatch('get_account')
        next({
          name: 'users',
          params: {
            association: 'Colleague', // TODO MVP will depend on account type?
            associationTitle: 'Users',
            associationTitleSingular: 'User'
          }
        })
      }

      const goToClients = async () => {
        await $store.dispatch('get_account')
        next({
          name: 'clients',
          params: {
            association: 'Client',
            associationTitle: 'Clients',
            associationTitleSingular: 'Client'
          }
        })
      }

      // redirect user to /dashboard if not OL admin
      if (to.path.includes('/oladmin')) {
        await $store.dispatch('get_appUser')
        if (!$store.getters.isAdmin) {
          next({ path: '/dashboard' })
        }
      }

      // redirect user to /dashboard if not admin
      if (to.path.includes('/admin')) {
        await $store.dispatch('get_appUser')
        if (!($store.getters.isAccountAdmin || $store.getters.isAdmin)) {
          next({ path: '/dashboard' })
        }
      }

      if (to.path === '/users') {
        if ($store.getters.isAdmin && !to.params.account) {
          next({ name: 'accounts/users' })
          return
        } else {
          if (!to.params.association) {
            goToUsers()
            return
          } else {
            next()
          }
        }
      }

      if (to.path === '/clients') {
        if ($store.getters.isAdmin && !to.params.account) {
          next({ name: 'accounts/clients' })
          return
        } else {
          if (!to.params.association) {
            goToClients()
            return
          } else {
            next()
          }
        }
      }

      next()
    })
  } else {
    next()
  }
})

router.afterEach(({ meta = {}, ...to }, from) => {
  logPageView({
    path: to.fullPath,
    title: meta.title,
    referrer: from.fullPath,
    meta
  })
})

export default router
